import { render, staticRenderFns } from "./ResearchLinesInformation.vue?vue&type=template&id=5d8d7e28&"
import script from "./ResearchLinesInformation.vue?vue&type=script&lang=js&"
export * from "./ResearchLinesInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports